import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
export function DeleteCompanyDepartmentPopupComponent({
  onDeleteSubmit,
  onDeleteCancel,
  departmentId,
  loading
}) {
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    open: true,
    onConfirm: () => onDeleteSubmit(departmentId),
    onCancel: onDeleteCancel,
    onClose: onDeleteCancel,
    loading: loading,
    msg: "Are you sure you want to delete the company department?"
  });
}